import { Navigate } from "react-router-dom";

import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { DataRequestTrashPage } from "@/domain/trash/routes/data-request-trash.page";

import { CreateDataRequestPage } from "./create-data-request.page";
import { DataEntryPageRoute } from "./data-entry.page";
import { DataRequestDetailPage } from "./data-request-detail.page";
import { DataRequestListLayout } from "./data-request-list.layout";
import { DataRequestListPage } from "./data-request-list.page";

const DATA_REQUEST_FEATURE_FLAG = "enable-data-request";

export const dataRequestRoutes = [
  {
    path: "data-requests",
    children: [
      {
        element: (
          <FeatureFlagToggle flag={DATA_REQUEST_FEATURE_FLAG} fallback={<Navigate to=".." replace />}>
            <DataRequestListLayout />
          </FeatureFlagToggle>
        ),
        children: [
          { index: true, element: <DataRequestListPage /> },
          { path: "trash", element: <DataRequestTrashPage /> },
        ],
      },
      {
        path: "create",
        element: (
          <FeatureFlagToggle flag={DATA_REQUEST_FEATURE_FLAG} fallback={<Navigate to=".." replace />}>
            <CreateDataRequestPage />
          </FeatureFlagToggle>
        ),
      },
      {
        path: ":dataRequestId",
        element: (
          <FeatureFlagToggle flag={DATA_REQUEST_FEATURE_FLAG} fallback={<Navigate to=".." replace />}>
            <DataRequestDetailPage />
          </FeatureFlagToggle>
        ),
      },
    ],
  },
  {
    path: "data-entry/:dataRequestEntityId",
    element: (
      <FeatureFlagToggle flag={DATA_REQUEST_FEATURE_FLAG} fallback={<Navigate to=".." replace />}>
        <DataEntryPageRoute />
      </FeatureFlagToggle>
    ),
  },
];
